// extracted by mini-css-extract-plugin
export default {"menuButton":"WUsCxbmbK6yy3vX1_OGD AisLsJaE_AWnIhDlnTUV"};